 //Fonctions liés au niveau de sécurité du mot de passe
 
 //Contrôle la complexité d'un mot de passe
 function scorePassword(pass) {
    var score = 0;
    if (!pass)
        return score;

    // award every unique letter until 5 repetitions
    var letters = new Object();
    for (var i=0; i<pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
    }
    
    // bonus points for mixing it up
    var variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass)
    };

    variationCount = 0;
    for (var check in variations) {
        variationCount += (variations[check] == true) ? 1 : 0;
    }
    score += (variationCount - 1) * 10;

    return parseInt(score, 10);
}

//Verifie la complexité du mot de passe
function checkPassStrength(pass) {
    var score = scorePassword(pass);
    if (score > 80)
        return "strong";
    if (score > 60)
        return "good";
    if (score >= 30 || (score < 30 && pass && pass.length >= 6))
        return "weak";
    return "none";
}

function updateSecurityBar($securityBar, strengthLevel) {
    if (['strong', 'good', 'weak', 'none'].indexOf(strengthLevel) === -1) {
        return false;
    }

    if (!$securityBar.length) {
        return false;
    }

    switch (strengthLevel) {
        case 'weak':
            $securityBar.removeClass('secondary').addClass('alert');
            $securityBar.find('.progress-meter').animate({width: '45%'});
            $securityBar.find('.progress-meter-text').text('Faible');
            break;
        case 'good':
            $securityBar.removeClass('secondary alert').addClass('warning');
            $securityBar.find('.progress-meter').animate({width: '75%'});
            $securityBar.find('.progress-meter-text').text('Moyen');
            break;
        case 'strong':
            $securityBar.removeClass('secondary alert warning').addClass('success');
            $securityBar.find('.progress-meter').animate({width: '100%'});
            $securityBar.find('.progress-meter-text').text('Fort');
            break;
        default:
            $securityBar.removeClass('success alert warning').addClass('secondary');
            $securityBar.find('.progress-meter').animate({width: '0%'});
            $securityBar.find('.progress-meter-text').text('');
            break;
    }
}